import { render, staticRenderFns } from "./vol.vue?vue&type=template&id=f13715cc&scoped=true"
import script from "./vol.vue?vue&type=script&lang=js"
export * from "./vol.vue?vue&type=script&lang=js"
import style0 from "./vol.vue?vue&type=style&index=0&id=f13715cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f13715cc",
  null
  
)

export default component.exports